import { useAccountLogo } from 'hooks/account.hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';

const AccountLogo: React.FC = () => {
  const { show, logoUrl, handleError } = useAccountLogo();
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <>
      <div aria-hidden className="mx-6 w-px h-7 bg-white/60" />
      <img
        src={logoUrl!}
        alt={t('global:account_logo_alt')}
        className="max-h-7 h-7 w-auto block object-contain"
        onError={handleError}
      />
    </>
  );
};

export default AccountLogo;
